<template>
    <v-dialog v-model="dialog" width="400px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Are you Sure? </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="py-3"><h3>{{ confirmText }}</h3></v-card-text>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="error" small @click="confirmAction">Confirm</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="cancelAction">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                confirmText: "",
                action: "",
            }
        },
        methods: { 
            openDialog(confirmText, action) {
                this.confirmText = confirmText;
                this.action = action;
                this.dialog = true;
            },
            confirmAction() {
                this.$emit("confirmAction", this.action);
                this.closeDialog();
            },
            cancelAction() {
                this.closeDialog();
            },
            closeDialog() {
                this.dialog = false;
            },
        }
    }
</script>